export const CAboutVideoFragments = {
  field: `
    fragment aboutVideo on aboutVideo_MatrixField {
      ... on aboutVideo_block_Entry {
        id
        typeHandle
        idName
        heading
        copy
        buttonLabel
        video {
          url
          title
          embeddedAsset {
            url
            title
          }
        }
      }
    }
  `,
}
